import { render } from "./Opname.vue?vue&type=template&id=039d6d94"
import script from "./Opname.vue?vue&type=script&lang=js"
export * from "./Opname.vue?vue&type=script&lang=js"

import "./Opname.vue?vue&type=style&index=0&id=039d6d94&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__